export const URL = "https://karaoke-backend.easyway.pro.vn"